import React, { Component } from 'react'

export default class ForgotPass extends Component {
    render() {
        return (
            <div>
                Didnt had time to add Forgot Password so mail me at <strong> mailsforakashkamat@gmail.com</strong> to know your password
            </div>
        )
    }
}
